// This is copied from packages/backend/lib/dbt/sync-util.ts:155
export function checkBelowMinimumDbtVersion(
  version: string,
  minimum: string,
): boolean {
  let [major, minor] = version.split(".").map((v) => parseInt(v));
  let [minMajor, minMinor] = minimum.split(".").map((v) => parseInt(v));

  major = major || 0;
  minMajor = minMajor || 0;
  minor = minor || 0;
  minMinor = minMinor || 0;

  return (major === minMajor && minor < minMinor) || major < minMajor;
}

// Mirrors DBT_DEPRECATED_VERSIONS in packages/backend/lib/dbt/versions.ts
const DEPRECATED_DBT_VERSIONS = ["1.10"];

export function isDeprecatedDbtVersion(version: string | null | undefined) {
  if (!version) {
    return false;
  }
  return DEPRECATED_DBT_VERSIONS.includes(
    version.split(".").slice(0, 2).join("."),
  );
}

/** A deprecated version stays selectable only for a config already on it. */
export function isDbtVersionOptionDisabled(
  optionVersion: string,
  currentVersion: string | null | undefined,
  minimumVersion: string,
) {
  if (checkBelowMinimumDbtVersion(optionVersion, minimumVersion)) {
    return true;
  }
  return (
    isDeprecatedDbtVersion(optionVersion) && optionVersion !== currentVersion
  );
}
